import { render, staticRenderFns } from "./gesture-tap.vue?vue&type=template&id=1189b96b&"
import script from "./gesture-tap.vue?vue&type=script&lang=ts&"
export * from "./gesture-tap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports